import * as cx from 'classnames';
import { count_WIKI_ARTICLE_EXPERIENCES } from 'mk/autogenerated/translations/ArticleBody.e856e25c53bec2d87f7697bac08b9f8d'
import {
    getInlinedImages,
    linebreaksbr,
    mentionize,
    replaceImageMarks,
    upperCaseFirst,
    urlize,
} from 'mk/bazaar/common/filters';
import { ArticleEntity } from 'mk2/apps/wiki/schemas';
import { cacheLast } from 'mk2/helpers/cache';
import { processNodeOfAST } from 'mk2/helpers/rendering_from_ast/filters';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import styles from './ArticleBody.mscss';

interface OwnProps {
    article: ArticleEntity;
    followLinks: boolean;
}

type Props = OwnProps;

export default class ArticleBody extends React.Component<Props> {

    private processNodeOfASTCache = cacheLast();

    public render() {
        const {
            article,
        } = this.props;

        // prepare article message body
        let bodyChunks: React.ReactChild[] = [];
        if (article.text !== '') {
            const additionalData = {
                countExperiences: article.countExperiences,
                countTopicContributors: article.countTopicContributors,
                categorySlugs: article.categorySlugs,
                linkedObjects: article.linkedObjects,
                photos: article.photos,
                photoStyle: styles.ArticleBody__photos,
            };

            // caching the bodyChunks using cacheLast (which memorize one value depending on cache keys) like the
            // memoize do (which memorize the return value of any function depending on cache keys). We cache an array,
            // base on the actual article as a cache key. The array contain the expensive function at the beginning.
            // After registering the array (array1) in the cache we change the content of the array and push the result
            // of the function. In the next executions of the render (if same cache keys) the array1 will be not equal
            // to array2.
            const expensiveFn = () => processNodeOfAST(article.bodyAST, additionalData);
            const array1 = [expensiveFn];
            const array2 = this.processNodeOfASTCache(array1, article.bodyAST);
            if (array1 === array2) {
                array2.pop();
                array2.push(expensiveFn());
            }
            bodyChunks = array2[0];
        }

        const hasExperiences = article.experiencesAllowed && article.experiences.length > 0;

        return (
            <div className={styles.ArticleBody}>
                <h1 className={cx(hasExperiences && styles['ArticleBody--hasExperiences'])}>{upperCaseFirst(article.title)}</h1>

                {hasExperiences && (
                    <a href="#experiences" className={styles.ArticleBody__headerLink}>
                        {interpolate(count_WIKI_ARTICLE_EXPERIENCES, {count: article.experiences.length})}
                        <i className={cx('fa fa-comment-o', styles.ArticleBody__headerLink__icon)} />
                    </a>
                )}

                {article.text !== '' && (
                    <div className={styles.ArticleBody__text}>
                        {bodyChunks}
                    </div>
                )}
            </div>
        );
    }
}
